import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import { grey } from '@mui/material/colors';
import { isLightTheme } from '../../../../../../lib/themes/theme';

export const styles = (theme: any) => {
  const colorPalette = theme.palette.primary as any;

  return createStyles({
    gridRow: {
      paddingBottom: 15,
    },
    overflowX: {
      overflowX: 'scroll',
    },
    textBox: {
      backgroundColor: isLightTheme() ? grey[200] : theme.palette.background.paper,
      padding: 10,
      color: theme.palette.primary.formItem,
    },
    label: {
      fontSize: 12,
      lineHeight: '15px',
      color: colorPalette.grey12,
      paddingBottom: 6,
    },
  });
};
